import {AfterViewInit, Component, ElementRef, Inject, QueryList, ViewChildren, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AnalysisManagementService} from '../../services/analysis-management.service';
import {HelperService} from '../../helper.service';
import {TranslateService} from '@ngx-translate/core';
import {MappingComponent} from '../../mapping/mapping.component';
import {NavBarComponent} from '../../nav-bar/nav-bar.component';
import {FarmAvailableMapsDto} from '../../dto/FarmAvailableMapsDto';
import {AvailableMapsFarmModel} from '../../models/availableMapsFarmModel';
import {AnalysisItemMapsFarmModel} from '../../models/analysisItemMapsFarmModel';
import {FarmOverlayItemModel} from '../../models/farmOverlayItemModel';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MapsTypesAvailabilityModel} from '../../models/mapsTypesAvailabilityModel';
import dayjs from 'dayjs';
import {ReportService, OrderingDefinition} from '../../services/report.service';
import {catchError, of} from 'rxjs';
import {AnalysisOrderingDefinitionsComponent} from '../analysis-ordering-definitions/analysis-ordering-definitions.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Role } from 'src/app/models/role';
import { ImageryRequestService, ImageryRequestDto } from 'src/app/services/imagery-request.service';

@Component({
    selector: 'app-map-data',
    templateUrl: './map-data-farm.component.html',
    styleUrls: ['./map-data-farm.component.css'],
    standalone: false
})
export class MapDataFarmComponent  implements AfterViewInit {

  @ViewChildren('navAnalysisItem') navAnalysisItems: QueryList<ElementRef>;

  selectionState: FormGroup;

  analysisTypes = this.data.analysis;
  farmNameHeader = this.data.farmNameHeader;
  farmId = this.data.farmID;
  date = this.data.date;
  type: string;

  selectedPeriod = '30 days';
  selectedVariance: number;
  currentPeriodRange = '';
  lastSelectedType: any;
  selectedTypeHl: any;
  optionExists: any;
  viewProfitability: boolean = false;
  roles: Role[] = JSON.parse(sessionStorage.getItem('roles'));

  filteredList: AvailableMapsFarmModel[] = [];
  availableItems: FarmAvailableMapsDto;
  selectedItem: FarmOverlayItemModel;

  selectedPeriodBtn = false;
  showAnalysisList = false;
  showChemList = false;
  disablePeriodRange = false;
  showNoDataCard = false;
  autoFocusOn = false;
  hideLoadMoreBtn = false;
  hideVarianceOptions = false;

  // Imagery Request
  showImageryRequestButton: boolean = false;
  imageryRequestDateOption: '30days' | '60days' | '90days' | 'custom' = '30days';
  imageryRequestDateFrom: Date = null;
  imageryRequestDateTo: Date = null;
  isRequestingImagery: boolean = false;
  imageryDateToday: string = '';
  imageryDate30DaysAgo: string = '';
  imageryRequestDateFromStr: string = '';
  imageryRequestDateToStr: string = '';
  showDateMenu: boolean = false;

  orderingDefinitions: OrderingDefinition[] = [];
  selectedOrderingDefinitionId: number | null = null;
  filteredItemObj = {
    period: '30 days',
    variance: 1,
    farmId: this.data.farmID,
    type: 'NDVI SATELLITE',
    pageSize: 25,
    pageNumber: 1,
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<MappingComponent>,
              public helper: HelperService,
              public translate: TranslateService,
              public analysisManagementService: AnalysisManagementService,
              public nav: NavBarComponent,
              private formBuilder: FormBuilder,
              private reportService: ReportService,
              private _snackBar: MatSnackBar,
              private dialog: MatDialog,
              private imageryRequestService: ImageryRequestService,
  ) {
    this.selectionState = this.formBuilder.group({
      prevSelect: ''
    });
  }

  ngOnInit(): void {
    this.viewProfitability = this.roles.some(r => r.name === 'ProfitabilityMapView');
    this.selectedVariance = 1;
    this.lastSelectedType = this.data.previousValue;
    let mapsTypesAvailabilityModel2: MapsTypesAvailabilityModel = {
      type: this.lastSelectedType?.type,
      available: true,
      alias: this.lastSelectedType?.alias,
      displayOrder: 1,
      selected: true
    };

    if (this.data.previousValue) {
      this.lastSelectedType = mapsTypesAvailabilityModel2;
    }

    if (this.farmNameHeader == '') {
      this.farmNameHeader = 'No Farm Selected';
    } else {
      this.farmNameHeader = this.data.farmNameHeader;
    }

    this.optionExists = [];
    this.analysisTypes.forEach(obj => {
      this.optionExists.push(obj.type);
    });

    if (this.lastSelectedType) {
      let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
        type: this.lastSelectedType.type,
        available: true,
        alias: this.lastSelectedType.alias,
        displayOrder: 1,
        selected: true
      };

      if (sessionStorage.getItem('lastSelectedPeriod') !== undefined) {
        this.selectedPeriod = sessionStorage.getItem('lastSelectedPeriod');
      }


      if (sessionStorage.getItem('lastSelectedVariance') !== undefined) {
        this.selectedVariance = +sessionStorage.getItem('lastSelectedVariance');
      }

      this.selectAnalysisType(mapsTypesAvailabilityModel);
    }
    // Set the default value based on the type

    else {

      let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
        type: this.analysisTypes[0].type,
        available: true,
        alias: this.analysisTypes[0].alias,
        displayOrder: 1,
        selected: true
      };

      this.analysisTypes.every(availableType => {
        if (availableType.available && availableType.type === 'NDVI SATELLITE') {
          mapsTypesAvailabilityModel = {
            type: availableType.type,
            available: true,
            alias: availableType.alias,
            displayOrder: 1,
            selected: true
          };
          return false;
        } else if (availableType.available) {
          mapsTypesAvailabilityModel = {
            type: availableType.type,
            available: true,
            alias: availableType.alias,
            displayOrder: 1,
            selected: true
          };
          return false;
        }
        return true;
      });


      this.selectionState.controls['prevSelect'].setValue(this.analysisTypes[0].type);

      this.selectAnalysisType(mapsTypesAvailabilityModel);
      this.clickPeriod(this.selectedPeriod);
    }

    this.selectedTypeHl = this.filteredItemObj.type;
    this.clickPeriod(this.selectedPeriod);
    this.clickVariance(this.selectedVariance);
  }

  selectAnalysisType(selectType: MapsTypesAvailabilityModel) {
    if(selectType?.alias === 'PROFITABILITY' && !this.viewProfitability) {
      this._snackBar.open(('You do not have permission to use this feature.'), this.translate.instant('SNACKBAR.DISMISS'), {
        duration: 10000,
      });
      this.nav.toggleLoading(false);
    } else {
      if (selectType.available) {

        this.analysisTypes.forEach(availableType => {

          if ((availableType.type !== selectType.type) || (availableType.alias !== selectType.alias)) {
            availableType.selected = false;
          } else {
            availableType.selected = true;
          }
          // used to download report
          this.type = selectType.type;
        });

        this.filteredList = [];
        let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
          type: selectType.type,
          available: true,
          alias: selectType.alias,
          displayOrder: 1,
          selected: true
        };

        this.selectionState.controls['prevSelect'].setValue(selectType.type);
        this.lastSelectedType = mapsTypesAvailabilityModel;
        this.filteredItemObj.type = selectType.type;

        if (this.filteredItemObj.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
          if (this.filteredItemObj.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
            this.disablePeriodRange = true;
            this.hideVarianceOptions = true;
            this.filteredItemObj.period = 'all';
            this.filteredItemObj.variance = this.selectedVariance;
          } else {
            this.disablePeriodRange = false;
            this.hideVarianceOptions = false;
            this.filteredItemObj.period = this.selectedPeriod;
            this.filteredItemObj.variance = this.selectedVariance;
          }
          this.showAnalysisList = true;
          this.showChemList = false;
        } else {
          this.filteredItemObj.period = 'all';
          this.filteredItemObj.variance = this.selectedVariance;
          this.showAnalysisList = false;
          this.showChemList = true;
          this.disablePeriodRange = true;
          this.hideVarianceOptions = true;
        }
        this.hideLoadMoreBtn = this.currentPeriodRange == 'all';
        this.selectedTypeHl = this.filteredItemObj.type;
        this.getFilteredList();
        this.updateImageryRequestVisibility();
      }
        this.loadOrderingDefinitions();
    }
  }

  getFilteredList() {

    this.nav.toggleLoading(true);

    let farmAvailableMapsDto: FarmAvailableMapsDto = {
      period: this.filteredItemObj.period,
      variance: this.filteredItemObj.variance,
      farmId: this.filteredItemObj.farmId,
      type: this.filteredItemObj.type,
      pageSize: this.filteredItemObj.pageSize,
      pageNumber: this.filteredItemObj.pageNumber,
    }
    this.analysisManagementService.getFarmAvailableMaps(farmAvailableMapsDto).subscribe(itemList => {

      if (this.filteredItemObj.pageNumber <= 1) {
        this.filteredList = itemList;

        ///////////////////////// LOAD MORE ////////////////////////////////////
      } else {
        itemList.forEach(item => {
          this.filteredList.push(item);
        })
      }


      if (itemList.length > 0) {
        this.showNoDataCard = true;
      } else {
        this.showNoDataCard = false;
      }
      this.nav.toggleLoading(false);
    });
  }

  clickPeriod(periodRange: string) {
    this.filteredItemObj.pageNumber = 1;

    this.selectedPeriod = periodRange;

    let lastSelectedPeriod = periodRange;
    sessionStorage.setItem('lastSelectedPeriod', lastSelectedPeriod);


    this.filteredItemObj.period = periodRange;
    this.hideLoadMoreBtn = periodRange == 'all';
    this.filteredList = [];
    this.getFilteredList();
  }

  clickVariance(varianceRange: number) {

    this.selectedVariance = varianceRange;

    let lastSelectedVariance = JSON.stringify(varianceRange);
    sessionStorage.setItem('lastSelectedVariance', lastSelectedVariance);

    this.filteredItemObj.variance = varianceRange;
    this.filteredList = [];
    this.getFilteredList();
  }


  loadMore() {
    this.filteredItemObj.pageNumber = this.filteredItemObj.pageNumber + 1;
    this.getFilteredList();
  }

  onCloseClick() {
    this.dialogRef.close();
  }

  public overlayAnalysis(date: string, type: string, item: AnalysisItemMapsFarmModel) {
    var result = {
      date: date,
      type: type,
      propertyTypeId: item.propertyTypeId,
      propertyTypeName: item.propertyTypeName,
    };
    this.selectedItem = result;
    this.dialogRef.close({
      "selectedItem": this.selectedItem,
      "lastSelectedType": this.lastSelectedType,
      "lastSelectedVariance": this.selectedVariance,
    });
    this.nav.toggleLoading(true);
  }

  ngAfterViewInit() {
    this.selectAnalysisType(this.lastSelectedType);
  }

  formatDate(date: string, format: string): string {
    return dayjs(date).format(format);
  }


  generateFarmAnalysis(date, event: Event) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(AnalysisOrderingDefinitionsComponent, {
      width: '400px',
      data: {
        orderingDefinitions: this.orderingDefinitions,
        selectedOrderingDefinitionId: this.selectedOrderingDefinitionId,
        showCombinedOption: this.type?.toLowerCase().includes('chemical'),
        farmId: this.farmId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == null) return;
      this.selectedOrderingDefinitionId = result.orderingDefinitionId;
      sessionStorage.setItem('selectedOrderingDefinitionId', result.orderingDefinitionId?.toString() || '');
      this.nav.toggleLoading(true);
      const reportType = result.combined ? 'chemical-combined' : this.type;
      this.reportService.generateFarmAnalysisReport(reportType, date, this.farmId, true, true, this.selectedOrderingDefinitionId, result.language, result.orientation, result.labelSize, result.fieldIds, result.labelColor, result.labelStrokeColor)
          .subscribe(response => {
            this.nav.toggleLoading(false);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 15000,
            });
          });
    });
  }

  loadOrderingDefinitions() {
    if (!this.type || !this.type.toLowerCase().includes('chemical')) {
      this.orderingDefinitions = [];
      return;
    }
    const analysisType = this.type.toLowerCase().includes('top') ? 'Top Soil' : 'Sub Soil';
    this.reportService.getOrderingDefinitions(analysisType).subscribe(defs => {
      this.orderingDefinitions = defs || [];
      const stored = sessionStorage.getItem('selectedOrderingDefinitionId');
      if (stored && this.orderingDefinitions.some(d => d.id === +stored)) {
        this.selectedOrderingDefinitionId = +stored;
      } else {
        const defaultDef = this.orderingDefinitions.find(d => d.isDefault);
        this.selectedOrderingDefinitionId = defaultDef ? defaultDef.id : (this.orderingDefinitions.length > 0 ? this.orderingDefinitions[0].id : null);
      }
    });
  }

  onOrderingDefinitionChange(id: number) {
    this.selectedOrderingDefinitionId = id;
    sessionStorage.setItem('selectedOrderingDefinitionId', id.toString());
  }

  /**
   * Check if the imagery request button should be shown
   * Only show for YARA NDVI SATELLITE type
   */
  updateImageryRequestVisibility(): void {
    const type = this.lastSelectedType?.type?.toUpperCase() || '';
    this.showImageryRequestButton = type === 'YARA NDVI SATELLITE';
    
    // Update date labels
    this.imageryDateToday = dayjs().format('DD MMM YYYY');
    this.imageryDate30DaysAgo = dayjs().subtract(30, 'day').format('DD MMM YYYY');
  }

    /**
   * Get label for selected date option
   */
  getDateOptionLabel(): string {
    switch (this.imageryRequestDateOption) {
      case '30days': return 'Last 30 Days';
      case '60days': return 'Last 60 Days';
      case '90days': return 'Last 90 Days';
      case 'custom': return 'Custom Range...';
      default: return 'Last 30 Days';
    }
  }

    /**
   * Handle date picker changes
   */
  onDateFromChange(dateStr: string): void {
    this.imageryRequestDateFromStr = dateStr;
    this.imageryRequestDateFrom = dateStr ? new Date(dateStr + 'T00:00:00') : null;
  }

  onDateToChange(dateStr: string): void {
    this.imageryRequestDateToStr = dateStr;
    this.imageryRequestDateTo = dateStr ? new Date(dateStr + 'T00:00:00') : null;
  }

    /**
   * Submit an imagery request for the entire farm
   */
  submitImageryRequest(): void {
    if (this.isRequestingImagery) return;

    this.isRequestingImagery = true;

    const request: ImageryRequestDto = {
      level: 'FARM',
      targetId: this.farmId,
      fileType: this.lastSelectedType?.type || 'YARA NDVI SATELLITE',
    };

    // Use dateFrom/dateTo format - set daysBack to null to signal scheduler to use actual dates
    if (this.imageryRequestDateOption === 'custom' && this.imageryRequestDateFrom) {
      request.dateFrom = dayjs(this.imageryRequestDateFrom).format('YYYY-MM-DD');
      request.dateTo = this.imageryRequestDateTo 
        ? dayjs(this.imageryRequestDateTo).format('YYYY-MM-DD') 
        : dayjs().format('YYYY-MM-DD');
      request.daysBack = null;  // Signal to use dateFrom/dateTo instead of calculating from today
    } else {
      // Preset date ranges
      let daysBack = 30;
      if (this.imageryRequestDateOption === '60days') daysBack = 60;
      else if (this.imageryRequestDateOption === '90days') daysBack = 90;
      
      request.dateFrom = dayjs().subtract(daysBack, 'day').format('YYYY-MM-DD');
      request.dateTo = dayjs().format('YYYY-MM-DD');
    }

    this.imageryRequestService.requestImagery(request).subscribe({
      next: (response) => {
        this.isRequestingImagery = false;
        this._snackBar.open(
          `Imagery request submitted for all fields on ${this.farmNameHeader}. Processing will take a few minutes.`,
          this.translate.instant('SNACKBAR.DISMISS'),
          { duration: 8000 }
        );
        // Reset form
        this.imageryRequestDateOption = '30days';
        this.imageryRequestDateFrom = null;
        this.imageryRequestDateTo = null;
      },
      error: (error) => {
        this.isRequestingImagery = false;
        console.error('Imagery request failed:', error);
        this._snackBar.open(
          'Failed to submit imagery request. Please try again.',
          this.translate.instant('SNACKBAR.DISMISS'),
          { duration: 5000 }
        );
      }
    });
  }
}